class SlideshowClassic extends HTMLElement {
  connectedCallback() {
    this.handleBlockSelect = this.showSelectedSlide.bind(this);
    this.handleBlockDeselect = this.resumeAutoplay.bind(this);
    this.handleSwiperLoad = this.initSlider.bind(this);

    this.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

    // swiperJs.js is lazy-loaded at the end of <body>, so it can run after this script
    if (window.Swiper) {
      this.initSlider();
      return;
    }

    document.addEventListener('load:swiper', this.handleSwiperLoad, { once: true });
  }

  disconnectedCallback() {
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    document.removeEventListener('load:swiper', this.handleSwiperLoad);

    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  initSlider() {
    const viewportElement = this.querySelector('[data-slider-viewport]');

    if (!viewportElement || !window.Swiper || this.slider) return;

    const { transition, autoplayDelay, loop } = this.dataset;
    const autoplayDelayMilliseconds = Number(autoplayDelay);

    this.slider = new window.Swiper(viewportElement, {
      loop: loop === 'true',
      speed: 500,
      autoHeight: true,
      grabCursor: true,
      effect: transition === 'fade' ? 'fade' : 'slide',
      fadeEffect: {
        crossFade: true,
      },
      autoplay:
        autoplayDelayMilliseconds > 0
          ? {
              delay: autoplayDelayMilliseconds,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }
          : false,
      navigation: {
        prevEl: this.querySelector('[data-slider-prev]'),
        nextEl: this.querySelector('[data-slider-next]'),
        disabledClass: 'slideshow-classic__arrow--disabled',
        lockClass: 'slideshow-classic__arrow--hidden',
      },
      pagination: {
        el: this.querySelector('[data-slider-pagination]'),
        clickable: true,
        bulletClass: 'slideshow-classic__bullet',
        bulletActiveClass: 'slideshow-classic__bullet--active',
        modifierClass: 'slideshow-classic__pagination--',
        horizontalClass: 'slideshow-classic__pagination--horizontal',
        clickableClass: 'slideshow-classic__pagination--clickable',
        lockClass: 'slideshow-classic__pagination--hidden',
      },
    });
  }

  showSelectedSlide(blockSelectEvent) {
    if (!this.slider) return;

    const slideIndex = Number(blockSelectEvent.target.dataset.slideIndex);

    if (Number.isNaN(slideIndex)) return;

    if (this.slider.autoplay.running) {
      this.slider.autoplay.stop();
    }

    this.slider.slideToLoop(slideIndex);
  }

  resumeAutoplay() {
    if (!this.slider || !this.slider.params.autoplay.enabled) return;

    this.slider.autoplay.start();
  }
}

if (!customElements.get('slideshow-classic')) {
  customElements.define('slideshow-classic', SlideshowClassic);
}
